<template>
<SrcBackground>
  <HeadlineSub :title="$t('menu.statistic')" target="/Main" :hassubline=true :hasmenu=false>
        <template #icon>
          <IconStatistic class="w-12 h-12"/>
        </template>
        <template #subline>
            <span v-if="isLoading">&nbsp;</span>
            <span v-if="!isLoading"><strong>{{subline}}</strong></span>
            <span v-if="!isLoading&&subline!=' '&&(statindex==stattotal)">:&nbsp;&nbsp;</span>
            <span v-if="!isLoading&&(statindex==stattotal)">{{ $t('statistic.loadcount', {count: fullstat[0] }) }}
              &nbsp;&nbsp;·&nbsp;&nbsp;{{ $t('statistic.energycount', {energy: $n( fullstat[1]/1000 ,'decimal1' ) }) }}
              &nbsp;&nbsp;·&nbsp;&nbsp;{{ $n( fullstat[2]/100 , 'currency') }}
            </span>
        </template>
  </HeadlineSub>

    <div class="px-4 my-6 max-w-5xl">

    <div class="w-full flex flex-col gap-2 md:gap-4 md:p-4 md:bg-skin-b-list-back md:border md:shadow md:rounded-2xl">

        <!-- 1. Zeile -->
        <div class="flex flex-col sm:flex-col md:flex-row gap-2 md:gap-4">
            <div class="flex-1">
                <div v-if="this.$store.state.Mesh" class="relative w-full inline-flex self-center">
                  <svg class="h-12 w-10 absolute ml-2 top-0 right-2 pointer-events-none p-2 text-skin-b-list-base" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd" d="M8 14.5V13h4v1.5Zm-3-3.75v-1.5h10v1.5ZM3 7V5.5h14V7Z" clip-rule="evenodd" />
                      </svg>
                  <select name="filterstatbox" id="filterstatbox" 
                  @change="filterpicker(filterwallbox,filteruser,filterrfid,dateValue[0],dateValue[1])" v-model="filterwallbox" 
                  class="w-full h-12 pl-4 pr-12 appearance-none truncate bg-none
                  rounded-lg cursor-pointer border-2 border-skin-b-list-bord
                  font-semibold text-lg text-skin-b-list-base
                  bg-skin-b-list-back
                  hover:bg-skin-b-list-head 
                  focus:border-skin-b-list-bord focus:ring-0
                  transition duration-300 ease-in-out">
                    <option class="bg-skin-active128/10 font-semibold" value="all" selected>{{ $t('statistic.allwallboxes') }}</option>
                    <option v-for="(gb, index) in groupclienttable" 
                    :key="index" 
                    :value="gb.id"
                    :class="{ 'bg-skin-active128/10 font-semibold': gb.id.slice(0,1)=='g' }"
                    >
                      {{gb.name}}
                    </option>
                  </select>  
                </div>
            </div>
            <div class="flex-1" v-if="usertable.length>0">
                <div class="relative w-full inline-flex self-center">
                  <svg class="h-12 w-10 absolute ml-2 top-0 right-2 pointer-events-none p-2 text-skin-b-list-base" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd" d="M8 14.5V13h4v1.5Zm-3-3.75v-1.5h10v1.5ZM3 7V5.5h14V7Z" clip-rule="evenodd" />
                      </svg>
                  <select name="filterstatrfid" id="filterstatrfid" 
                  @change="filterpicker(filterwallbox,filteruser,filterrfid,dateValue[0],dateValue[1])" v-model="filteruser" 
                  class="w-full h-12 pl-4 pr-12 appearance-none truncate bg-none
                  rounded-lg cursor-pointer border-2 border-skin-b-list-bord
                  font-semibold text-lg text-skin-b-list-base
                  bg-skin-b-list-back
                  hover:bg-skin-b-list-head 
                  focus:border-skin-b-list-bord focus:ring-0
                  transition duration-300 ease-in-out">
                    <option class="bg-skin-active128/10 font-semibold" value="-1" selected>{{ $t('statistic.allusers') }}</option>
                    <option v-for="(user, index) in usertable" :key="index" :value="user.userId">
                      <span v-if="user.alias">{{user.alias}} - </span>
                      <span>{{user.name}}</span> 
                    </option>
                  </select>  
                </div>
            </div>
            <div class="flex-1">
                <div class="relative w-full inline-flex self-center">
                  <svg class="h-12 w-10 absolute ml-2 top-0 right-2 pointer-events-none p-2 text-skin-b-list-base" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd" d="M8 14.5V13h4v1.5Zm-3-3.75v-1.5h10v1.5ZM3 7V5.5h14V7Z" clip-rule="evenodd" />
                      </svg>
                  <select name="filterstatrfid" id="filterstatrfid" 
                  @change="filterpicker(filterwallbox,filteruser,filterrfid,dateValue[0],dateValue[1])" v-model="filterrfid" 
                  class="w-full h-12 pl-4 pr-12 appearance-none truncate bg-none
                  rounded-lg cursor-pointer border-2 border-skin-b-list-bord
                  font-semibold text-lg text-skin-b-list-base
                  bg-skin-b-list-back
                  hover:bg-skin-b-list-head 
                  focus:border-skin-b-list-bord focus:ring-0
                  transition duration-300 ease-in-out">
                    <option class="bg-skin-active128/10 font-semibold" value="-1" selected>{{ $t('statistic.allrfids') }}</option>
                    <option v-for="(rfid, index) in filteredpairings" :key="index" :value="rfid.token">
                      {{rfid.info}}
                    </option>
                  </select>  
                </div>
            </div>
        </div>

        <!-- 2. Zeile -->
        <div class="flex flex-col sm:flex-col md:flex-row gap-2 md:gap-4">

            <vue-tailwind-datepicker class="flex-1"
                    v-model="dateValue"
                    v-slot="{ value, placeholder, clear }"
                    :formatter="formatter"
                    :shortcuts="customShortcuts"
                    :options="options"
                    @update:model-value="filterpicker(filterwallbox,filteruser,filterrfid,dateValue[0],dateValue[1]);checksubline(dateValue[0],dateValue[1]);"
                    :i18n=this.$i18n.locale
                    :separator="$t('statistic.separator')"
                    :placeholder="$t('statistic.placeholder')"
                    as-single use-range overlay
                  >
                    <div class="flex">
                      <div class="flex-1">
                        <button
                          type="button"
                          class="block w-full h-12 p-2 
                                leading-6 sm:px-6 items-center justify-center space-x-2 sm:space-x-4
                                font-semibold text-lg
                                rounded-l-lg border-2 border-skin-b-list-bord 
                                bg-skin-b-list-back
                                hover:bg-skin-b-list-head 
                                focus:outline-none focus:ring-0 
                                
                                transition duration-300 ease-in-out"
                        >
                          <span class="text-skin-b-list-base">
                            {{ value || placeholder }}
                          </span>
                        </button>
                      </div>
                      <div class="flex-shrink-0">
                        <button
                          type="button"
                          class="block flex-none h-12 p-2
                          leading-6 sm:px-4 items-center justify-center space-x-2 sm:space-x-4 
                          font-semibold text-lg text-skin-b-list-base
                          rounded-r-lg border-y-2 border-r-2 border-skin-b-list-bord
                          bg-skin-b-list-back
                          hover:bg-skin-b-list-head 
                          focus:outline-none focus:ring-0 
                          transition duration-300 ease-in-out"
                          @click="clear"
                        >
                          <svg
                            class="w-6 h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M6 18L18 6M6 6l12 12"
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </div>
            </vue-tailwind-datepicker>
            
            <button v-if="!errormsgshow" @click="LoadingCSV()" class="
                        inline-block cursor-pointer px-4
                        py-2 h-12
                        rounded-lg border-2 border-transparent
                        font-semibold text-lg text-skin-b-invt 
                        bg-skin-active128 text-skin-inverted
                        disabled:opacity-50 disabled:hover:bg-skin-active128 
                        hover:bg-skin-active96
                        focus:bg-skin-active128 focus:outline-none focus:ring-0 
                        active:bg-skin-active128 
                        transition duration-300 ease-in-out">
              <svg class="inline-block mr-2 h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M5.5 16q-.625 0-1.062-.438Q4 15.125 4 14.5V13h1.5v1.5h9V13H16v1.5q0 .625-.438 1.062Q15.125 16 14.5 16Zm3.75-3V5.875L7.062 8.062 6 7l4-4 4 4-1.062 1.062-2.188-2.187V13Z" clip-rule="evenodd" />
              </svg>
              {{ $t('statistic.exportcsv') }}
              </button>
        </div>

    </div>

      <div v-if="errormsgshow" class="flex h-20">
        <div class="my-auto w-full">  
          <h4 class="font-bold text-xl text-center text-skin-b-base">{{errormsg}}</h4>
        </div>
      </div>    
      <loading-overlay :active="isLoading" :is-full-page="false" :width="128" :height="128" :loader="loader" :color="loadercolor" :background-color="loaderbackcolor" />
      <div class="pb-20">
        <div class="text-skin-b-base" v-for="(statyear, index) in lvstatistic" :key="index">
          <a class="cursor-pointer" @click="statyear.yearopen=!statyear.yearopen">
          <div class="flex h-20">
            <div class="my-auto">
              <h4 class="font-bold text-xl truncate text-skin-b-base">          
              <svg :class="{'rotate-90': statyear.yearopen, 'inline-block -mt-1 mr-2': true}" xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="currentColor">
                <path d="m6 18-1.417-1.417L11.167 10 4.583 3.417 6 2l8 8Z"/>
              </svg>
                  <span class="inline-block">{{ statyear.year }}</span>
                  <span class="inline-block sm:hidden">
                    &nbsp;&nbsp;<small>
                    ({{ statyear.yearcount }}&nbsp;·&nbsp;
                    {{ $t('statistic.energycount', {energy: $n( statyear.yearenergy/1000 ,'decimal1' ) }) }}
                    &nbsp;·&nbsp;
                    {{ $n( statyear.yearcost/100 , 'currency') }}
                    )</small></span>
              </h4>
              
            </div>
            
            <div class="flex-auto my-auto text-right hidden sm:inline-block">
              <h4 class="font-regular text-skin-b-mute">          
                  <span class="">
                    {{ $t('statistic.loadcount', {count: statyear.yearcount }) }}
                    &nbsp;&nbsp;·&nbsp;&nbsp;
                    {{ $t('statistic.energycount', {energy: $n( statyear.yearenergy/1000 ,'decimal1' ) }) }}
                    &nbsp;&nbsp;·&nbsp;&nbsp;
                    {{ $n( statyear.yearcost/100 , 'currency') }}
                  </span>
              </h4>
            </div>
          </div>
          </a>

          <div v-if="statyear.yearopen">
          <div class="mb-6" v-for="(statmonth, index) in statyear.yearmonth" :key="index">
            <a class="cursor-pointer" @click="statmonth.monthopen=!statmonth.monthopen">
            <div class="flex h-8">
              <div class="my-auto">
                <h4 class="font-medium text-lg truncate text-skin-b-base">
                    <svg :class="{'rotate-90': statmonth.monthopen, 'inline-block -mt-1': true}" xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="currentColor">
                      <path d="m8 15-1.062-1.062L10.875 10 6.938 6.062 8 5l5 5Z"/>
                    </svg>
                    <span class="inline-block">{{ statmonth.month }}&nbsp;{{ statyear.year }}</span>
                    <span class="inline-block sm:hidden">

                      &nbsp;&nbsp;<small>
                      ({{ statmonth.monthcount }}
                      &nbsp;·&nbsp;
                      {{ $t('statistic.energycount', {energy: $n( statmonth.monthenergy/1000 ,'decimal1' ) }) }}
                      &nbsp;·&nbsp;
                      {{ $n( statmonth.monthcost/100 , 'currency') }})</small></span>
                </h4>
              </div>
              <div class="my-auto ml-4 hidden sm:inline-block">
                <h4 class="font-regular text-skin-b-mute">
                  <span class="">
                    {{ $t('statistic.loadcount', {count: statmonth.monthcount }) }}
                    &nbsp;&nbsp;·&nbsp;&nbsp;
                    {{ $t('statistic.energycount', {energy: $n( statmonth.monthenergy/1000 ,'decimal1' ) }) }}
                    &nbsp;&nbsp;·&nbsp;&nbsp;
                    {{ $n( statmonth.monthcost/100 , 'currency') }}
                  </span>                  
              </h4>
              </div>
            </div>
            </a>

              <ul v-if="statmonth.monthopen" class="bg-skin-b-list-back border border-skin-b-list-bord shadow mt-4 mb-6 rounded-lg">
                <li class="" v-for="(statentry, index) in statmonth.loadentry" :key="index">

                  <div class="p-4 flex items-center group">
                    <!-- Left Icon oder Alias -->
                    <div
                      v-if="statentry.loadalias"
                      class="flex-shrink-0 mr-4 rounded-lg border border-slate-300"
                      :style="{ backgroundColor: statentry.loadcolor }"
                    >
                      <p class="w-12 h-12 px-1 py-2.5 text-center">
                        <span class="text-lg font-semibold text-white">{{ statentry.loadalias }}</span>
                      </p>
                    </div>
                    <div v-else class="flex-shrink-0 mr-4 rounded-lg border border-slate-300" :style="{ backgroundColor: statentry.loadcolor }">
                      <IconCar class="m-1 w-10 h-10" fill="#ffffff" />
                    </div>

                    <div class="grow">
                      <div class="mb-2">
                      <span class="text-skin-b-list-base"><strong>{{ statentry.loadday }} {{ statentry.loaddate }} - {{ statentry.loadstart }}</strong></span>
                      <span v-if="statentry.loadclient!=''" class="text-skin-b-list-mute">&nbsp;&nbsp;&#8231;&nbsp;&nbsp;<strong>{{ statentry.loadclient }}</strong></span>
                      <span v-if="statentry.loaduser!=''" class="hidden sm:inline-block text-skin-b-list-mute">&nbsp;&nbsp;&#8231;&nbsp;&nbsp;<strong>{{ statentry.loaduser }}</strong></span>
                      <span v-if="statentry.loadrfid!=''" class="hidden sm:inline-block text-skin-b-list-mute">&nbsp;&nbsp;&#8231;&nbsp;&nbsp;<strong>{{ statentry.loadrfid }}</strong></span>
                      </div>
                      <div class="text-skin-b-mute">
                        <span>
                          <!--
                          <svg class="inline-block -mt-1" xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="currentColor">
                            <path d="m12.792 13.542 1.062-1.063-3.104-3.104V5h-1.5v5ZM10 18q-1.646 0-3.104-.625-1.458-.625-2.552-1.719t-1.719-2.552Q2 11.646 2 10q0-1.667.625-3.125t1.719-2.542Q5.438 3.25 6.896 2.625T10 2q1.667 0 3.125.625t2.542 1.708q1.083 1.084 1.708 2.542Q18 8.333 18 10q0 1.646-.625 3.104-.625 1.458-1.708 2.552-1.084 1.094-2.542 1.719Q11.667 18 10 18Zm0-8Zm0 6.5q2.708 0 4.604-1.906T16.5 10q0-2.708-1.896-4.604T10 3.5q-2.688 0-4.594 1.896Q3.5 7.292 3.5 10q0 2.688 1.906 4.594Q7.312 16.5 10 16.5Z"/>
                          </svg>-->
                          <IconClock class="inline-block -mt-1 w-5 h-5" />
                          {{ statentry.loadtime }}&nbsp;
                          <!--
                          <svg class="inline-block -mt-1" xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="currentColor">
                            <path d="m8.5 17 1-5.5H6.625q-.292 0-.385-.156-.094-.156.031-.406L10.5 3h1L11 8.5h2.375q.271 0 .375.146.104.146-.042.416L9.5 17Z"/>
                          </svg>-->
                          <IconBolt class="inline-block -mt-1 w-5 h-5" />
                          {{ $t('statistic.energycount', {energy: $n( statentry.loadenergy ,'decimal1' ) }) }}
                          &nbsp;&nbsp;
                          <!--
                          <svg class="inline-block -mt-1" xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="currentColor">
                            <path d="m11.5 2.5c-1.536604 0-2.9307935.25717-4.0078125.71875-.538511.23079-1.0016601.5124922-1.3632813.8789062-.2013622.2040319-.3674665.4479271-.4804687.7167969.8349122-.1917055 1.7379868-.2985163 2.6953125-.3085937.8127968-.299991 1.921818-.5058594 3.15625-.5058594 1.362891 0 2.592909.2448966 3.416016.5976562.411553.17638.71701.3807754.886718.5527344.169709.171958.197266.2753914.197266.3496094 0 .07422-.02756.1776514-.197266.3496094-.169708.171959-.475165.3763543-.886718.5527344-.07514.032204-.170237.0575886-.251954.0878906.326941.3549719.607621.8019462.744141 1.3261718.0315-.012939.06863-.0218782.099609-.0351562.177179-.0759306.332257-.1676994.492188-.2558594v.9746094c0 .07422-.02756.1776514-.197266.3496094-.07272.073687-.18249.155485-.302734.2363281v1.6972655c.0024-.001.005513-.000898.007812-.001953.17718-.07593.332257-.167699.492188-.255859v.974609c0 .07422-.02756.177651-.197266.349609-.07272.07369-.18249.155484-.302734.236329v1.697265c.0024-.001.005512-.000898.007812-.001953.538511-.23079 1.001661-.512492 1.363282-.878906.361644-.366367.628906-.855241.628906-1.402344v-6c0-.547103-.267286-1.0359298-.628906-1.4023438-.361621-.366414-.824771-.6481162-1.363282-.8789062-1.077017-.46158-2.471208-.71875-4.007812-.71875zm-3 3c-1.536604 0-2.9307935.25717-4.0078125.71875-.538511.23079-1.0016603.5124923-1.3632813.8789062-.36162.366414-.6289062.8552408-.6289062 1.4023438v6c0 .547103.2672863 1.03593.6289062 1.402344.361621.366414.8247693.648116 1.3632813.878906 1.077018.46158 2.4712085.71875 4.0078125.71875s2.930793-.25717 4.007812-.71875c.538511-.23079 1.001661-.512492 1.363282-.878906.36162-.366414.628906-.855241.628906-1.402344v-6c0-.547103-.267286-1.0359298-.628906-1.4023438-.361621-.366414-.824771-.6481162-1.363282-.8789062-1.077018-.46158-2.471208-.71875-4.007812-.71875zm0 1.5c1.362891 0 2.592909.2448966 3.416016.5976562.411553.17638.71701.3807754.886718.5527344.169709.171958.197266.2753914.197266.3496094 0 .07422-.02756.1776514-.197266.3496094-.169708.171959-.475165.3763544-.886718.5527344-.823107.3527599-2.053125.5976562-3.416016.5976562s-2.5929086-.2448963-3.4160156-.5976562c-.411553-.17638-.7170108-.3807754-.8867188-.5527344-.169709-.171958-.1972656-.2753914-.1972656-.3496094 0-.07422.0275596-.1776514.1972656-.3496094.169708-.171959.4751658-.3763543.8867188-.5527344.823107-.3527597 2.0531246-.5976562 3.4160156-.5976562zm-4.5 3.525391c.159931.08816.3150085.179925.4921875.255859 1.077019.46158 2.4712085.71875 4.0078125.71875s2.930793-.25717 4.007812-.71875c.177179-.07593.332257-.167699.492188-.255859v.974609c0 .07422-.02756.177651-.197266.349609-.169708.171959-.475165.376355-.886718.552735-.823107.35276-2.053125.597656-3.416016.597656s-2.5929086-.244896-3.4160156-.597656c-.411553-.17638-.7170108-.380776-.8867188-.552735-.169709-.171958-.1972656-.275391-.1972656-.349609zm0 3c.159931.08816.3150075.179925.4921875.255859 1.077018.46158 2.4712085.71875 4.0078125.71875s2.930793-.25717 4.007812-.71875c.177179-.07593.332257-.167699.492188-.255859v.974609c0 .07422-.02756.177651-.197266.349609-.169708.171959-.475165.376355-.886718.552735-.823107.35276-2.053125.597656-3.416016.597656s-2.5929086-.244896-3.4160156-.597656c-.411553-.17638-.7170108-.380776-.8867188-.552735-.169709-.171958-.1972656-.275391-.1972656-.349609z"/>
                          </svg>-->
                          <IconMoney class="inline-block -mt-1 w-5 h-5" />
                          {{ $n( statentry.loadcost , 'currency') }}
                          &nbsp;&nbsp;
                        </span>
                        <span>
                          <button @click="getcalibration(statentry.loadclientid,statentry.loadremoteid);">   
                            <IconFingerprint class="inline-block -mt-1 w-5 h-5" />
                          </button>
                        </span>
                      </div>
                    </div>

                  </div>
                  <div v-if="index<statmonth.loadentry.length-1" class="border-b border-skin-b-list-bord"></div>

                </li>
              </ul>


          </div>
          </div>

          <div v-if="index<lvstatistic.length-1" class="bottom-0 left-0 w-full border-b-2 border-skin-b-list-bord"></div>



          <div v-if="calibmodal" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                      <div class="p-6 text-center w-full">
                        <h1 class="mb-5 text-xl font-bold">
                          {{ $t('statistic.calibdata') }}
                        </h1>
                        <h3 class="mb-5 text-lg font-semibold break-words">
                          {{ calibinfo }}
                        </h3>
                        <div>
                          <button v-if="caliburl!=''" @click.prevent="submitForm" @click="opencalibration();calibmodal=false;" type="button" 
                                    class="px-4 py-2 h-12 m-2
                                    rounded-lg border-2 border-transparent
                                    font-semibold text-lg text-skin-b-invt 
                                    bg-skin-active128
                                    disabled:opacity-50 disabled:hover:bg-skin-active128 
                                    hover:bg-skin-active96
                                    focus:bg-skin-active128 focus:outline-none focus:ring-0 
                                    active:bg-skin-active128 
                                    transition duration-300 ease-in-out">
                                    {{ $t('common.loaddata') }}
                          </button>
                          <button @click.prevent="submitForm" @click="calibmodal=false;" type="button" 
                                    class="px-4 py-2 h-12 m-2
                                    rounded-lg border-2 border-transparent
                                    font-semibold text-lg text-skin-b-invt 
                                    bg-skin-active128
                                    disabled:opacity-50 disabled:hover:bg-skin-active128 
                                    hover:bg-skin-active96
                                    focus:bg-skin-active128 focus:outline-none focus:ring-0 
                                    active:bg-skin-active128 
                                    transition duration-300 ease-in-out">
                                    {{ $t('common.close') }}
                          </button>                          
                        </div>

                      </div>
                  </div>
              </div>
          </div>
          

          <div v-if="statindex<stattotal" class="w-full mt-6">     
          <button @click.prevent="submitForm" @click="loadmore()" class="
          w-full px-4 py-2 h-12
          rounded-lg border-2 border-transparent
          font-semibold text-lg text-skin-b-invt 
          bg-skin-active128
          disabled:opacity-50 disabled:hover:bg-skin-active128 
          hover:bg-skin-active96
          focus:bg-skin-active128 focus:outline-none focus:ring-0 
          active:bg-skin-active128 
          transition duration-300 ease-in-out">
            {{ $t('statistic.loadmore') }} ({{ statindex+1 }} / {{ stattotal+1 }})
          </button>

          </div>
        </div>
      </div>

    </div>

</SrcBackground>
</template>

<script>
import IconStatistic from './icons/IconStatistic.vue'
import SrcBackground from './sources/SrcBackground.vue'
import HeadlineSub from './elements/HeadlineSub.vue'
import IconCar from './icons/IconCar.vue'
import IconClock from './icons/IconClock.vue'
import IconBolt from './icons/IconBolt.vue'
import IconMoney from './icons/IconMoney.vue'
import IconFingerprint from './icons/IconFingerprint.vue'
import { ref } from 'vue'
import VueTailwindDatepicker from 'vue-tailwind-datepicker'
import { useI18n } from 'vue-i18n'
export default {
  name: 'StatisticsPage',
  components: {
      IconStatistic,
      SrcBackground, HeadlineSub,
      IconCar, IconBolt, IconClock, IconMoney, IconFingerprint,
      VueTailwindDatepicker
    },
    setup() {
    const { t,d,n } = useI18n();    
    const date = new Date();
    const dateValue = ref([
              new Date(date.getFullYear(), 0, 1),
              date
              //new Date(date.setDate(date.getDate() - 30)), 
              //new Date(date.setDate(date.getDate() + 30))
            ]);
    const formatter = ref({
                            date: 'DD.MM.YYYY',
                            month: 'MMM'
                          });
    const options = ref({
      footer: {
        apply: 'apply',
        cancel: 'cancel'
      }
    });

    const customShortcuts = () => {
      const { t } = useI18n();
      return [
      {
          label: t('statistic.today'),
          atClick: () => {
            const date = new Date();
            return [
              date, 
              date
            ];
          }
        },
        {
          label: t('statistic.yesterday'),
          atClick: () => {
            const date = new Date();
            return [
              new Date(date.setDate(date.getDate() - 1)), 
              new Date(date.setDate(date.getDate()))
            ];
          }
        },
        {
          label: t('statistic.thisweek'),
          atClick: () => {
            const date = new Date();
            var first = date.getDate() - date.getDay() + 1;
            return [
              new Date(date.setDate(first)), 
              new Date(date.setDate(date.getDate()+6))
            ];
          }
        },
        {
          label: t('statistic.lastweek'),
          atClick: () => {
            const date = new Date();
            var first = date.getDate() - date.getDay() + 1 - 7;
            return [
              new Date(date.setDate(first)), 
              new Date(date.setDate(date.getDate()+6))
            ];
          }
        },
        {
          label: t('statistic.thismonth'),
          atClick: () => {
            const date = new Date();
            return [
              new Date(date.getFullYear(), date.getMonth(), 1),
              new Date(date.getFullYear(), date.getMonth() + 1, 0)
            ];
          }
        },
        {
          label: t('statistic.lastmonth'),
          atClick: () => {
            const date = new Date();
            return [
              new Date(date.getFullYear(), date.getMonth() - 1, 1),
              new Date(date.getFullYear(), date.getMonth(), 0)
            ];
          }
        },
        {
          label: t('statistic.thisyear'),
          atClick: () => {
            const date = new Date();
            return [
              new Date(date.getFullYear(), 0, 1),
              date
            ];
          }
        },
        {
          label: t('statistic.lastyear'),
          atClick: () => {
            const date = new Date();
            return [
              new Date(date.getFullYear() - 1, 0, 1),
              new Date(date.getFullYear() - 1, 12, 0)
            ];
          }
        },     
      ];
    }

                                         
    return {
      dateValue,
      formatter,
      options,
      customShortcuts,
      t,d,n
    };
  },
  data() {
      return { 
        filterrfid: '-1',
        filterwallbox: 'b'+this.$store.state.WbId,
        filteruser: '-1',
        calibmodal: false,
        caliburl: '',
        calibinfo: '',
        selectuser: false,
        errormsgshow: false,
        errormsg: this.$t('statistic.errormsg'),
        stattotal: 0,
        statindex: 0,
        monate: ['Alle',this.$t('statistic.jan'),this.$t('statistic.feb'),this.$t('statistic.mar'),
                        this.$t('statistic.apr'),this.$t('statistic.may'),this.$t('statistic.jun'),
                        this.$t('statistic.jul'),this.$t('statistic.aug'),this.$t('statistic.sep'),
                        this.$t('statistic.oct'),this.$t('statistic.nov'),this.$t('statistic.dec')],
        tage: [this.$t('statistic.sun'),this.$t('statistic.mon'),this.$t('statistic.tue'),
              this.$t('statistic.wed'),this.$t('statistic.thu'),this.$t('statistic.fri'),this.$t('statistic.sat')],
        fullstat: [0,0,0],
        rfidtable: [],
        clienttable: [],
        client_info: [],
        grouptable: [],
        usertable: [],
        groupclienttable: [],     
        statisticapi: [],
        lvstatistic: [],
        isLoading: false,
        loader: "spinner",
        loadercolor: 'rgb(var(--color-active-hsl-128))',
        loaderbackcolor: 'rgb(var(--color-b-back))',
        statviewinit: true,
        subline: '',
      };
    },
    computed: {
      filteredpairings() {
        if (this.isLoading) {
          return [];
        }
        if (this.filteruser=='-1') return this.rfidtable;
        return this.rfidtable.filter(item => item.user === this.filteruser);
      }
    },
    methods: {
      decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
      },
      opencalibration(){
        const link = document.createElement('a');
        link.href = this.caliburl;
        link.target = '_blank';
        link.download = 'calibration.xml';
        link.click();
      },
      getcalibration(clientId,remoteId){
        this.axios
                .get('wallbox/info.php?action=get_statistic_calibration&client='+clientId+'&remoteId='+remoteId+'&user='+this.$store.state.token)
                .then((RESPONSE) => {
                  if(RESPONSE.data.status=='ok'){
                      console.log(RESPONSE);
                      if(RESPONSE.data.calibration!=''){
                          this.caliburl = RESPONSE.data.calibration;
                          this.calibinfo = RESPONSE.data.calibration;
                      }else{
                          this.caliburl = '';
                          this.calibinfo = this.$t('statistic.nocalibdata');
                      }
                  }else{
                    this.caliburl = '';
                    this.calibinfo = this.$t('statistic.nocalibdata');
                  }
                  this.calibmodal = true;
                })
                .catch((errors) => {
                    console.log(errors); // Errors
                }); 
      },
      fillstat() {
        if (!Array.isArray(this.statisticapi) || this.statisticapi.length === 0) {
          this.lvstatistic = [];
          return;
        }

        const g = [{
          year: '0',
          yearopen: true,
          yearcount: 0,
          yearcounttxt: 'Ladung',
          yearenergy: 0,
          yearcost: 0,
          yearmonth: [{
            month: '0',
            monthopen: true,
            monthcount: 0,
            monthcounttxt: 'Ladung',
            monthenergy: 0,
            monthcost: 0,
            loadentry: []
          }]
        }];

        const mapRFID = token => {
          if (token === '##FREE_CHARGING##')
            return { alias: '', username: '', rfidname: '', color: '#6b7280' };

          const entry = this.rfidtable?.find(r => r.token === token);
          const user = this.usertable?.find(u => u.userId === entry?.user);

          return {
            alias: user
              ? `${user.alias}`
              : '',            
            username: user
              ? `${user.name}`
              : '',
            rfidname: this.decodeHtml(entry?.info ?? ''),
            color: entry?.color ? `#${entry.color}` : '#6b7280'
          };
        };

        const getBoxName = clientId =>
          this.$store.state.Mesh
            ? this.decodeHtml(this.clienttable?.find(b => b.id == clientId)?.name ?? '')
            : this.client_info.name;

        this.statisticapi.forEach(item => {
          const loadbox = getBoxName(item.client);

          const tzOffset = new Date(item.start).getTimezoneOffset();
          const stopTz = this.$dayjs(item.stop).subtract(tzOffset, 'minute');
          const startTz = this.$dayjs(item.start).subtract(tzOffset, 'minute');

          const jahr = stopTz.format('YYYY');
          const monat = this.monate[stopTz.format('M')];
          const datum = startTz.format('DD.MM.');
          const tag = this.tage[startTz.format('d')];
          const startzeit = this.$t('common.time', { time: startTz.format('HH:mm') });

          const sec = stopTz.diff(startTz, 'second');
          const min = Math.floor(sec / 60);
          const hr = Math.floor(min / 60);
          const ladezeit = sec < 3600
            ? this.$t('statistic.loadtimeshort', { minutes: min, seconds: (`0${sec % 60}`).slice(-2) })
            : this.$t('statistic.loadtime', { hours: hr, minutes: (`0${min % 60}`).slice(-2) });

          const { alias: Kurzname, username: Benutzer, rfidname: KartenName, color } = mapRFID(item.user);

          let y = g.find(x => x.year === jahr);
          if (!y) {
            y = {
              year: jahr,
              yearopen: false,
              yearcount: 0,
              yearcounttxt: 'Ladung',
              yearenergy: 0,
              yearcost: 0,
              yearmonth: []
            };
            g.push(y);
          }

          y.yearcount++;
          y.yearcounttxt = 'Ladungen';
          y.yearenergy += item.energy;
          y.yearcost += item.price;

          let m = y.yearmonth.find(x => x.month === monat);
          if (!m) {
            m = {
              month: monat,
              monthopen: false,
              monthcount: 0,
              monthcounttxt: 'Ladung',
              monthenergy: 0,
              monthcost: 0,
              loadentry: []
            };
            y.yearmonth.push(m);
          }

          m.monthcount++;
          m.monthcounttxt = 'Ladungen';
          m.monthenergy += item.energy;
          m.monthcost += item.price;
          m.loadentry.push({
            loadclient: loadbox,
            loadclientid: item.client,
            loadremoteid: item.remoteId,
            loaddate: datum,
            loadday: tag,
            loadstart: startzeit,
            loadtime: ladezeit,
            loadenergy: item.energy / 1000,
            loadcost: item.price / 100,
            loadalias: Kurzname,
            loaduser: Benutzer,
            loadrfid: KartenName,
            loadcolor: color
          });
        });

        // NICHT mutierend (splice entfernte Originaldaten!)
        this.lvstatistic = g.slice(1);

        if (this.statviewinit) {
          this.lvstatistic[0].yearopen = true;
          this.lvstatistic[0].yearmonth[0].monthopen = true;
        } else {
          const last = this.lvstatistic[this.lvstatistic.length - 1];
          last.yearopen = true;
          last.yearmonth[last.yearmonth.length - 1].monthopen = true;
        }
      },

      convertToUTC(dateString, timeString) {
          // Convert "DD.MM.YYYY" to "YYYY-MM-DD"
          let [day, month, year] = dateString.split(".");
          let localDate = new Date(`${year}-${month}-${day}T${timeString}`);
          // Format the date and time for the URL
          return localDate.toISOString().replace("T", " ").split(".")[0]; // Remove milliseconds
      },
      filterpicker(filterbox,filteruser,filter,filterstart,filterend){
            
            this.isLoading = true;

            if(filterstart==undefined&&filterend==undefined){

            if(filteruser!='-1'&&filter=='-1'){
              filter = '##USERID##'+filteruser;
            }

              let statisticUrl = '';
              if(this.$store.state.Mesh){
                if(filterbox=='all')
                  statisticUrl = 'wallbox/info.php?action=load_remote_statistic&user='+this.$store.state.token+'&client=all&start=-1&end=-1&token='+filter+'&group=-1';
                else if(filterbox.slice(0,1)=='g')
                  statisticUrl = 'wallbox/info.php?action=load_remote_statistic&user='+this.$store.state.token+'&client=-1&start=-1&end=-1&token='+filter+'&group='+filterbox.slice(1);
                else
                  statisticUrl = 'wallbox/info.php?action=load_remote_statistic&user='+this.$store.state.token+'&client='+filterbox.slice(1)+'&start=-1&end=-1&token='+filter+'&group=-1';
              }else{
                statisticUrl = 'wallbox/info.php?action=load_remote_statistic&user='+this.$store.state.token+'&client=-1&start=-1&end=-1&token='+filter+'&group=-1';
              }
              this.axios
                .get(statisticUrl)
                .then((response) => {

                  if(response.data.status=='ok'){
                  this.statisticapi=[];                     
                    if(response.data.tbl_remote_statistic==''){
                      this.errormsgshow = true;
                      this.fullstat=[0,0,0];
                      this.fillstat();
                      this.isLoading = false;
                    }else{
                      this.errormsgshow = false;
                    this.statisticapi=response.data.tbl_remote_statistic;
                    

                    this.statviewinit = true;          
                    this.fillstat();
                    this.stattotal = Number(response.data.table_pages)-1;
                    this.statindex = Number(response.data.table_pages_index);
                    if(this.statisticapi.length>0&&(this.statindex==this.stattotal)){
                      this.fullstat[0] = this.statisticapi.length;
                      this.fullstat[1] = this.statisticapi.reduce((acc, item) => acc + item.energy, 0);
                      this.fullstat[2] = this.statisticapi.reduce((acc, item) => acc + item.price, 0);
                    }else{
                      this.fullstat=[0,0,0];
                    }
                    this.isLoading = false;
                    }
                  }else{
                    console.log('Error get statistics Operator Admin');
                  }
                })
                .catch((errors) => {
                    console.log(errors); // Errors
                });

            }else{
            let dateStartUTC = this.convertToUTC(filterstart, "00:00:00");
            let dateEndUTC = this.convertToUTC(filterend, "23:59:59");
            let baseUrl = 'wallbox/info.php?action=load_remote_statistic';
            let userToken = this.$store.state.token;
            let client = '-1';
            let group = '-1';

            if (this.$store.state.Mesh) {
                if (filterbox === 'all') {
                    client = 'all';
                } else if (filterbox.startsWith('g')) {
                    group = filterbox.slice(1);
                } else {
                    client = filterbox.slice(1);
                }
            }

            if(filteruser!='-1'&&filter=='-1'){
              filter = '##USERID##'+filteruser;
            }

            let statisticUrl = `${baseUrl}&user=${userToken}&client=${client}&start=${encodeURIComponent(dateStartUTC)}&end=${encodeURIComponent(dateEndUTC)}&token=${encodeURIComponent(filter)}&group=${group}`;
                      
            this.axios
                .get(statisticUrl)
                .then((response) => {          
                  if(response.data.status=='ok'){
                  this.statisticapi=[];                    
                    if(response.data.tbl_remote_statistic==''){
                      this.errormsgshow = true;
                      this.fullstat=[0,0,0];
                      this.fillstat();
                      this.isLoading = false;
                    }else{
                      this.errormsgshow = false;
                      this.statisticapi=response.data.tbl_remote_statistic;
                      this.statviewinit = true;       
                      this.fillstat();
                      this.stattotal = Number(response.data.table_pages)-1;
                      this.statindex = Number(response.data.table_pages_index);
                      if(this.statisticapi.length>0&&(this.statindex==this.stattotal)){
                        this.fullstat[0] = this.statisticapi.length;
                        this.fullstat[1] = this.statisticapi.reduce((acc, item) => acc + item.energy, 0);
                        this.fullstat[2] = this.statisticapi.reduce((acc, item) => acc + item.price, 0);
                      }else{
                        this.fullstat=[0,0,0];
                      }
                      this.isLoading = false;
                    }
                  }else{
                    console.log('Error get statistics Operator Admin');
                  }

                })
                .catch((errors) => {
                    console.log(errors); // Errors
                });    

            }


      },
      loadmore(){
        this.statindex++;
        this.axios
                .get('wallbox/info.php?action=get_remote_statistic&user='+this.$store.state.token+'&index='+this.statindex)
                .then((response) => {              
                  if(response.data.status=='ok'){
                    this.statisticapi=this.statisticapi.concat(response.data.tbl_remote_statistic);
                    this.statviewinit = false;            
                    this.fillstat();
                    this.stattotal = Number(response.data.table_pages)-1;
                    this.statindex = Number(response.data.table_pages_index);
                    if(this.statisticapi.length>0&&(this.statindex==this.stattotal)){
                      this.fullstat[0] = this.statisticapi.length;
                      this.fullstat[1] = this.statisticapi.reduce((acc, item) => acc + item.energy, 0);
                      this.fullstat[2] = this.statisticapi.reduce((acc, item) => acc + item.price, 0);
                    }else{
                      this.fullstat=[0,0,0];
                    }
                  }else{
                    console.log('Error get loadmore statistics Operator Admin');
                  }

                })
                .catch((errors) => {
                    console.log(errors); // Errors
                });         
      },
      checksubline(start,end) {
        if(start==undefined&&end==undefined){
          this.subline = ' ';
        }else{
          const date = new Date();
          if(this.$dayjs(date).format('DD.MM.YYYY')==start&&this.$dayjs(date).format('DD.MM.YYYY')==end)
            this.subline = this.$t('statistic.today');
          else if(this.$dayjs(date.setDate(date.getDate() - 1)).format('DD.MM.YYYY')==start&&this.$dayjs(date.setDate(date.getDate())).format('DD.MM.YYYY')==end)
            this.subline = this.$t('statistic.yesterday');
          else if(this.$dayjs(date.setDate(date.getDate() - date.getDay() + 1)).format('DD.MM.YYYY')==start&&this.$dayjs(date.setDate(date.getDate()+6)).format('DD.MM.YYYY')==end)
            this.subline = this.$t('statistic.thisweek');
          else if(this.$dayjs(date.setDate(date.getDate() - date.getDay() + 1 - 7)).format('DD.MM.YYYY')==start&&this.$dayjs(date.setDate(date.getDate()+6)).format('DD.MM.YYYY')==end)
          this.subline = this.$t('statistic.lastweek');       
          else if(this.$dayjs(new Date(date.getFullYear(), date.getMonth(), 1)).format('DD.MM.YYYY')==start&&this.$dayjs(new Date(date.getFullYear(), date.getMonth() + 1, 0)).format('DD.MM.YYYY')==end)
          this.subline = this.$t('statistic.thismonth');
          else if(this.$dayjs(new Date(date.getFullYear(), date.getMonth() - 1, 1)).format('DD.MM.YYYY')==start&&this.$dayjs(new Date(date.getFullYear(), date.getMonth(), 0)).format('DD.MM.YYYY')==end)
          this.subline = this.$t('statistic.lastmonth'); 
          else if(this.$dayjs(new Date(date.getFullYear(), 0, 1)).format('DD.MM.YYYY')==start&&this.$dayjs(new Date()).format('DD.MM.YYYY')==end)
          this.subline = this.$t('statistic.thisyear');  
          else if(this.$dayjs(new Date(date.getFullYear() - 1, 0, 1)).format('DD.MM.YYYY')==start&&this.$dayjs(new Date(date.getFullYear() - 1, 12, 0)).format('DD.MM.YYYY')==end)
          this.subline = this.$t('statistic.lastyear'); 
          else
            //this.subline = 'vom '+this.tage[this.$dayjs(start.split(".").reverse().join("-")).format('d')]+' '+start+' bis '+this.tage[this.$dayjs(end.split(".").reverse().join("-")).format('d')]+' '+end;          
            this.subline = this.$t('statistic.fromto', { datestart: start , dateend: end }); 
        }

      },
      LoadingCSV() {
        let tzOffset = 0;

        // --- LABEL BUILDER ---
        const getBoxLabel = () => {
          if (this.$store.state.Mesh) {
            if (this.filterwallbox === 'all') return '';
            
            const box = this.groupclienttable.find(gb => gb.id === this.filterwallbox);
            let label = box?.name ?? '';
            // wenn Filter "bX" ist → führendes "b:" entfernen
            if (this.filterwallbox.startsWith('b')) label = label.slice(2);

            return `_${label}`;
          }

          return `_${this.$store.state.WbName}`;
        };

        const getUserLabel = () => {
          if (this.filteruser === '-1') return '';
          const user = this.usertable.find(u => u.userId === this.filteruser);
          return `_${user?.name}` ?? '';
        };

        const getRfidLabel = () => {
          if (this.filterrfid === '-1') return '';
          const r = this.rfidtable.find(r => r.token === this.filterrfid);
          return `_${r?.info}` ?? '';
        };

        const formatDate = (d) => {
          if (!d) return '';
          const [day, month, year] = d.split('.');
          return `${year}-${month}-${day}`;
        };

        const getDateLabel = () => {
          if (!Array.isArray(this.dateValue) || this.dateValue.length === 0) {
            return this.$t('statistic.csvallloads');
          }

          const [from, to] = this.dateValue;

          const fromFmt = formatDate(from);
          const toFmt   = formatDate(to);

          if (from === to) {
            return `${this.$t('statistic.csvloads')}_${fromFmt}`;
          }

          return `${this.$t('statistic.csvloads')}_${fromFmt}_${toFmt}`;
        };

        const boxlabel = getBoxLabel();
        const userlabel = getUserLabel();
        const rfidlabel = getRfidLabel();
        const datelabel = getDateLabel();

        const sanitizeFilename = s =>
          s.replace(/[ÄÖÜäöüß]/g, m => 'AE OE UE ae oe ue ss'.split(' ')[
            'ÄÖÜäöüß'.indexOf(m)
          ])
          .replace(/\s+/g, '_')
          .replace(/[^\w-]/g, '')
          .replace(/_+/g, '_');

        let templateString = sanitizeFilename(
          `${datelabel}${boxlabel}${userlabel}${rfidlabel}`
        );

        //Bitte folgendes für template String umformen:
        // Ersetze alle Leerzeichen mit '_'
        // Ersetze alle deutschen Umlaute ÄÜÖäüöß mit AEUEOEaeueoess
        // Entferne folgende Zeichen .,/\
        // Der String ist ein Dateiname und es sollen alle Zeichen umgebaut werden sodass sie keine Probleme machen

        // --- FILE REQUEST ---
        this.axios
          .get(`wallbox/info.php?action=get_remote_statistic_csv&user=${this.$store.state.token}&timeoffset=${tzOffset}`)
          .then((response) => {              
            if (response.data.status !== 'ok') {
              console.log('Error get loadmore statistics Operator Admin');
              return;
            }

            this.axios.get(response.data.link, { responseType: 'blob' })
              .then(res => {
                const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);

                // 🔍 Datumslogik aufgeräumt
                //const datePrefix = this.dateValue === ''
                //  ? this.$t('statistic.csvallloads')
                //  : `${this.dateValue[0].replaceAll('.', '-')}_-_${this.dateValue[1].replaceAll('.', '-')}`;

                // 🔥 Template String sauber
                link.download = `${templateString}.csv`;

                link.click();
                URL.revokeObjectURL(link.href);
              })
              .catch(console.error);
          })
          .catch(console.error);
      },

      // --- Shared helpers -------------------------------------------------------
      decodeClient(item) {
        if (!item) return item;
        if (item.name) item.name = this.decodeHtml(item.name);
        if (item.info) item.info = this.decodeHtml(item.info);
        return item;
      },

      decodeArray(arr) {
        if (!Array.isArray(arr)) return [];
        arr.forEach(item => {
          this.decodeClient(item);
        });
        return arr;
      },

      // --- Mesh mode ------------------------------------------------------------
      async loadMeshData() {
        const token = this.$store.state.token;

        const pairingUrl   = `wallbox/pairing.php?action=list_dist_pairings&user=${token}`;
        const allclientUrl = `wallbox/client.php?action=get_clients&user=${token}`;
        const allgroupsUrl = `wallbox/client.php?action=get_groups&user=${token}`;
        const allusersUrl = `wallbox/user.php?action=user_reload&user=${token}`;

        const [pairingRes, clientsRes, groupsRes, usersRes] = await Promise.all([
          this.axios.get(pairingUrl),
          this.axios.get(allclientUrl),
          this.axios.get(allgroupsUrl),
          this.axios.get(allusersUrl),
        ]);

        const pairingData = pairingRes.data;
        const clientsData = clientsRes.data;
        const groupsData  = groupsRes.data;
        const usersData  = usersRes.data;

        // Token invalid in any of the three → bail out quickly
        if (
          pairingData.status === 'token' ||
          clientsData.status === 'token' ||
          groupsData.status === 'token' ||
          usersData.status === 'token'
        ) {
          this.$router.push({ path: '/' });
          return;
        }

        // --- Pairings ---
        if (pairingData.status === 'ok') {
          const tbl = pairingData.tbl_remote_pairing || [];
          tbl.forEach(item => {
            if (item.info) item.info = this.decodeHtml(item.info);
          });
          tbl.sort((a, b) =>
            a.info.localeCompare(b.info, 'de', { sensitivity: 'base' })
          );
          this.rfidtable = tbl;
        } else {
          console.log('Error get pairings Operator Admin');
          this.rfidtable = [];
        }

        // --- Clients ---
        if (clientsData.status === 'ok') {
          const clients = this.decodeArray(clientsData.tbl_clients || []);

          // single sort with primary / secondary keys
          clients.sort((a, b) => {
            if (b.groupId !== a.groupId) return b.groupId - a.groupId; // groupId desc
            return a.idx - b.idx;                                      // idx asc
          });

          this.clienttable = clients;
        } else {
          console.log('Error get AllClients Operator Admin');
          this.clienttable = [];
        }

        // --- Groups ---
        if (groupsData.status === 'ok') {
          const groups = this.decodeArray(groupsData.tbl_groups || []);
          groups.sort((a, b) => b.id - a.id); // id desc
          this.grouptable = groups;
        } else {
          console.log('Error get AllGroups Operator Admin');
          this.grouptable = [];
        }

        // --- Users ---
        if (usersData.status === 'ok') {
          const users = usersData.tbl_user || [];
          users.forEach(item => {
            if (item.name) item.name = this.decodeHtml(item.name);
            if (item.alias) item.alias = this.decodeHtml(item.alias);
            if (item.address) item.address = this.decodeHtml(item.address);
            if (item.reference) item.reference = this.decodeHtml(item.reference);
            if (item.info) item.info = this.decodeHtml(item.info);
            if (item.email) item.email = this.decodeHtml(item.email);
          });
          users.sort((a, b) => {
            const aKey = (a.name || a.alias || a.email || '').trim();
            const bKey = (b.name || b.alias || b.email || '').trim();
            return aKey.localeCompare(bKey, 'de', { sensitivity: 'base' });
          });
          this.usertable = users;
        } else {
          console.log('Error get pairings Operator Admin');
          this.usertable = [];
        }
        
        // --- Build groupclienttable (clients + groups) ---
        this.buildGroupClientTable(clientsData.status, groupsData.status);
        this.statviewinit = true;
      },

      buildGroupClientTable(clientStatus, groupStatus) {
        this.groupclienttable = [];

        if (clientStatus !== 'ok' || groupStatus !== 'ok') {
          console.log('Error make GroupClientTable Operator Admin');
          return;
        }

        const groups  = this.grouptable || [];
        const clients = this.clienttable || [];

        if (groups.length === 1) {
          // Only one group → flat list with bullets
          clients.forEach(box => {
            if (box.wallboxStatus !== 'no_connection') {
              this.groupclienttable.push({
                id: 'b' + box.id,
                // box.name is already decoded
                name: '• ' + box.name
              });
            }
          });
          return;
        }

        // Multiple groups → group headers + boxes
        // Pre-group clients by groupId to avoid O(G*C) nested loops
        const clientsByGroup = new Map();
        for (const box of clients) {
          if (box.wallboxStatus === 'no_connection') continue;
          const list = clientsByGroup.get(box.groupId) || [];
          list.push(box);
          clientsByGroup.set(box.groupId, list);
        }

        for (const grp of groups) {
          const groupId = grp.id;
          this.groupclienttable.push({
            id: 'g' + groupId,
            // grp.name already decoded
            name: this.$t('statistic.group') + ': ' + grp.name
          });

          const boxes = clientsByGroup.get(groupId) || [];
          for (const box of boxes) {
            this.groupclienttable.push({
              id: 'b' + box.id,
              name: '• ' + box.name // already decoded
            });
          }
        }

        // Rename last group header to "no assignment"
        for (let i = this.groupclienttable.length - 1; i >= 0; i--) {
          const row = this.groupclienttable[i];
          if (row.id && row.id[0] === 'g') {
            row.name = this.$t('mesh.noassignment');
            break;
          }
        }
        //console.log('this.groupclienttable',this.groupclienttable);
        //console.log('this.usertable',this.usertable);
        //console.log('this.rfidtable',this.rfidtable);
      },

      // --- Non-Mesh mode --------------------------------------------------------
      async loadSingleClientData() {
        const token = this.$store.state.token;

        const pairingUrl    = `wallbox/pairing.php?action=get_pairings&user=${token}`;
        const clientInfoUrl = `wallbox/client.php?action=client_info&user=${token}`;

        const [pairingRes, clientInfoRes] = await Promise.all([
          this.axios.get(pairingUrl),
          this.axios.get(clientInfoUrl)
        ]);

        const pairingData    = pairingRes.data;
        const clientInfoData = clientInfoRes.data;

        // Pairings
        if (pairingData.status === 'ok') {
          const tbl = pairingData.tbl_pairing || [];
          tbl.forEach(item => {
            if (item.info) item.info = this.decodeHtml(item.info);
          });
          this.rfidtable = tbl;
        } else if (pairingData.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else {
          console.log('Error get pairings Operator Admin ohne Mesh');
          this.rfidtable = [];
        }

        // Client info
        if (clientInfoData.status === 'ok') {
          const info = clientInfoData.tbl_clientsettings || {};
          if (info) {
            if (info.name) info.name = this.decodeHtml(info.name);
            if (info.info) info.info = this.decodeHtml(info.info);
          }
          this.client_info = info;
        } else if (clientInfoData.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else {
          console.log('Error get client_info Operator Admin ohne Mesh');
          this.client_info = {};
        }
      },

    },
    mounted () {
    },   
    async created() {
      this.isLoading = true;

      try {
        if (this.$store.state.Mesh) {
          await this.loadMeshData();
        } else {
          await this.loadSingleClientData();
        }

        this.fillstat();
        this.subline = this.$t('statistic.thisyear');
      } catch (err) {
        console.error('Error in created():', err);
      } finally {
        this.isLoading = false;
      }
    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
